import Swiper from 'swiper'
import cache from '../../js/utilities/cache'

const enable = () => {
  if (cache.$galleryStory.length) {
    window.gallery = new Swiper(cache.$galleryStory, {
      pagination: '.swiper-paginations-story',
      paginationClickable: true,
      direction: 'horizontal',
      loop: true,
      speed: 250,
      autoplayDisableOnInteraction: false,
      grabCursor: true,
      effect: 'fade',
    })
  }
}

export default { enable }
